import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const OrderConfirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [orderCart, setOrderCart] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        const cartFromLocation = location.state?.cart;
        const savedCart = cartFromLocation || JSON.parse(localStorage.getItem("orderCart")) || [];

        if (cartFromLocation) {
            localStorage.setItem("orderCart", JSON.stringify(cartFromLocation));
        }

        setOrderCart(savedCart);

        const calculatedTotal = savedCart.reduce((total, item) => total + item.variant.price * item.quantity, 0);
        setTotalPrice(calculatedTotal.toFixed(2));

        window.scrollTo(0, 0);
    }, [location.state]);

    return (
        <div className="min-h-screen flex flex-col bg-black text-rose-300">
            <Header />

            {/* Main Container */}
            <div className="flex-grow flex items-center justify-center py-12 px-4 mt-16 sm:mt-20">
                <div className="w-full max-w-4xl bg-opacity-20 backdrop-blur-lg border border-rose-300 p-6 sm:p-8 rounded-lg shadow-lg glass animate-fade-in transition-transform duration-500 hover:scale-105">
                    {/* Confirmation Message */}
                    <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-4 sm:mb-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
                        🎉 Order Confirmed!
                    </h2>
                    <p className="text-center text-base sm:text-lg mb-6 sm:mb-10 leading-relaxed">
                        Thank you for shopping with us. Your order has been placed successfully.
                    </p>

                    {/* Order Details */}
                    <div className="space-y-4 max-h-64 sm:max-h-80 overflow-y-auto scrollbar-thin scrollbar-thumb-rose-300">
                        {orderCart.map((item, index) => (
                            <div
                                key={index}
                                className="flex items-center border-b border-rose-300 pb-4 hover:bg-rose-100 hover:bg-opacity-10 transition duration-300 rounded-lg p-2"
                            >
                                <img
                                    src={item.variant.image_url}
                                    alt={item.variant.color || item.variant.model}
                                    className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg border border-rose-300 mr-3 sm:mr-4 shadow-md"
                                />
                                <div className="flex-grow">
                                    <p className="font-semibold text-sm sm:text-base">{item.variant.color || item.variant.model}</p>
                                    <p className="text-xs sm:text-sm">Qty: {item.quantity}</p>
                                    <p className="text-xs sm:text-sm">Price: ${item.variant.price.toFixed(2)}</p>
                                </div>
                                <p className="text-right text-sm sm:text-base font-bold">
                                    ${(item.variant.price * item.quantity).toFixed(2)}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Total Price */}
                    <div className="text-right mt-6">
                        <h3 className="text-xl sm:text-2xl font-bold">Total: ${totalPrice}</h3>
                    </div>

                    {/* Back to Home Button */}
                    <div className="flex justify-center mt-10">
                        <button
                            onClick={() => navigate("/home")}
                            className="px-6 sm:px-8 py-3 sm:py-4 rounded-lg bg-rose-300 text-black text-base sm:text-lg font-semibold hover:bg-rose-400 transition shadow-md hover:scale-105"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>

            <Footer />
        </div>

    );
};

export default OrderConfirmation;
